import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { OverlaySideFormService } from '../../shared/overlay-side-form/overlay-side-form.service';

@Component({
  selector: 'app-main-ana-soggetto',
  templateUrl: './main-ana-soggetto.component.html',
  styleUrls: ['./main-ana-soggetto.component.css']
})
export class MainAnaSoggettoComponent implements OnInit {

  constructor(private userComponentService: ComponentService,
      private _overlaySideFormService: OverlaySideFormService,
      private _overlaySidePanelService: OverlaySideFormService,
      private componentFactoryResolver: ComponentFactoryResolver) { }
//TrasportatoriComponent
//SoggettoComponent
  ngOnInit() {
    let tabsJson1 =[
      
     /* {
        id:0,
        title: '',
        icon: 'user',
        component:'SoggettoComponent',
        data:[
          {
            idSoggetto:1,
            idSede:1,
          }
        ]
      },*/
      {
        id:1,
        title: '',
        icon: 'user',
        component:'AnaSoggettoComponent',
        data:[
          {
            IdTabella:1,
            data:'',
            NomeTabella:'soggetto'
          }
        ]
      },
      /*{
        id:2,
        title: '',
        icon: 'car',
        component:'AutomezzoComponent',
        data:[
          {
            idSoggetto:1,
            idSede:1,
          }
        ]
      }*/
    ];

    this.userComponentService.setTabs("Soggettotabs1",tabsJson1);
    
  }

}
